import React from 'react';

function ContactForm() {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-800 via-gray-900 to-black text-gray-300">
      <h2 className="text-2xl font-bold text-center mb-8 text-gray-200">Get In Touch</h2>
      <form className="max-w-lg mx-auto bg-gray-100 p-8 rounded-3xl shadow-md hover:shadow-lg">
        {/* Name Input */}
        <div className="mb-6">
          <label className="block font-semibold text-gray-700 mb-2">Your Name</label>
          <input
            type="text"
            className="w-full p-4 rounded-lg border border-gray-300 bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-primaryColor"
            placeholder="Enter your name"
          />
        </div>

        {/* Email Input */}
        <div className="mb-6">
          <label className="block font-semibold text-gray-700 mb-2">Your Email</label>
          <input
            type="email"
            className="w-full p-4 rounded-lg border border-gray-300 bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-primaryColor"
            placeholder="Enter your email"
          />
        </div>

        {/* Message Input */}
        <div className="mb-6">
          <label className="block font-semibold text-gray-700 mb-2">Your Message</label>
          <textarea
            rows="4"
            className="w-full p-4 rounded-lg border border-gray-300 bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-primaryColor"
            placeholder="Type your message"
          ></textarea>
        </div>

        {/* Submit Button */}
        <button className="w-full bg-primaryColor text-white py-4 rounded-lg shadow-lg hover:shadow-xl transition-transform transform hover:scale-105">
          Submit
        </button>
      </form>
    </section>
  );
}

export default ContactForm;